import { ITEM_STATE_SCHEDULED } from '../../../vars/itemStatus.js'
import getComposedEventPath from '../../../functions/getComposedEventPath.js'
import yItemsLoop from '../classes/yItemsLoop.js'

export default [
    function () {
        return {
            templateUrl: '/partial/app.partials.rundown.directives.navigation',
            replace: false,
            controller: [
                '$http',
                '$scope',
                '$rootScope',
                '$state',
                'selector',
                '$mdDialog',
                '$mdToast',
                'Item',
                'widgets',
                '$element',
                rmRundownNavigationCtrl
            ],
            controllerAs: 'ctrl',
            scope: {
                yBlocks: '=',
                blocks: '=',
                broadcastId: '=',
                badgeType: '=',
                widgetDragging: '=',
                templates: '=',
                rundownInfo: '=',
                currentFilters: '=',
                readOnly: '=',

                itemModelTypes: '='
            }
        }
    }
]

class rmRundownNavigationCtrl extends yItemsLoop {

    constructor ($http, $scope, $rootScope, $state, selector, $mdDialog, $mdToast, Item, widgets, $element) {
        super()

        this.$http = $http
        this.$scope = $scope
        this.$rootScope = $rootScope
        this.$state = $state
        this.selector = selector
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.Item = Item
        this.widgets = widgets
        this.$element = $element
        this.isDragging = false
        this.isCreateItemAllowed = true

        this.rundownInfo = $scope.rundownInfo
        this.readOnly = $scope.readOnly
        this.currentFilters = $scope.currentFilters

        // $scope.$on('active_station_filters_update', (block, event, filters) => {
        //     // console.log(filters);
        //     // console.log(block.items[block.items.length - 1]);
        // });

        $rootScope.blockMayAllowTemplate = {}

        this.scrollContainer = this.$element.children().first()[0]
        this.navContainer = this.$element.children().find('.nav-container')[0]
        this.maxScroll = null
        this.maxOffset = null
        this.itemHeight = 40
        this.blockHeight = 20
        this.itemBufferSize = 3
        this.view = []
        this.tempInView = {}

        // this.onObserveDeepHandler = this.onObserveDeep.bind(this);

        $scope.yItems = {}

        let unReg = $scope.$watch(() => {
            return $scope.yBlocks
        }, (newValue) => {
            if (newValue) {
                this.extraItemData = this.selector.extraItemData
                this.yBlocks = $scope.yBlocks
                unReg()
            }
        })

        this.checkNextClick()
    }

    getModelType (modelTypeId) {
        return this.$scope.itemModelTypes
            .find(modelType => `${modelType.id}` === `${modelTypeId}`)
    }

    updateSelection (blockId) {
        let yItems = this.yBlocks[blockId].get('items').toArray()
        this.selector.selectedItems.forEach(val => {
            if (yItems.indexOf(val) === -1) {
                this.selector.remove(val)
            }
        })
    }

    initBlock (blockId) {
        let unRegister = this.$scope.$watch(
            () => {
                const { yBlocks } = this
                if (yBlocks[blockId] && yBlocks[blockId].get('items')) {
                    return yBlocks[blockId]
                }
                return null
            },
            yBlock => {
                if (yBlock && yBlock.observeDeep) {

                    unRegister()

                    let length = 0

                    const deepHandler = events => {
                        events.forEach(event => {
                            if (event instanceof Y.YArrayEvent) {
                                if (event.target.length < length) {
                                    length = event.target.length
                                    this.updateSelection(blockId)
                                }
                            }
                        })
                    }

                    this.$scope.yItems[yBlock.get('id')] = this.getItemsFromYBlock(yBlock)

                    yBlock.observeDeep(deepHandler)
                    this.$scope.$on('$destroy', () => {
                        yBlock.unobserveDeep(deepHandler)
                    })

                }
            }
        )
    }

    validateRundown (yBlock) {
        const block = yBlock.toJSON()
        const items = block.items.map(({ id, updated_at }) => ({ id, updated_at }))
        this.$http.post(`items/validate-rundown/block/${block.id}`, items)
            .then(res => { console.log(res.data, res) })
    }

    countFilterItems (blockId) {
        return document.getElementById('nav-block-' + blockId).querySelectorAll('li:not(.no-items)').length
    }

    applyTemplate (yBlock, templateId) {
        this.$http.post('/templateblocks/apply', { block_id: yBlock.get('id'), template_id: templateId })
    }

    deleteTemplate (yBlock) {
        this.$http.post('/templateblocks/delete', { block_id: yBlock.get('id') })

    }

    checkNextClick () {
        if (this.readOnly) return

        let checkSelectionUp = e => {
            if (e.keyCode === 27) { //unselected (27 = escape)
                this.$scope.$apply(() => {
                    this.selector.removeAll()
                })
            } else if ((e.keyCode === 68 || e.keyCode === 46) && this.shouldCheckNextClick) { //delete fucntion (68 = d, 46 = delete)
                if (this.selector.selectedItems.length > 0) {
                    this.removeItems(this.selector.selectedItems)
                }
            }
        }

        let checkClick = () => {
            if (this.shouldCheckNextClick) {
                this.shouldCheckNextClick = false

                this.selector.removeAll()

                this.$scope.$apply()
            }
        }

        window.addEventListener('keyup', checkSelectionUp)
        window.addEventListener('click', checkClick)

        this.$scope.$on('$destroy', () => {
            window.removeEventListener('keyup', checkSelectionUp)
            window.removeEventListener('click', checkClick)
        })
    }

    removeItems (items, $event) {
        this.$mdDialog.show({
            controller: 'ConfirmManyDialogCtrl',
            templateUrl: 'confirmManyDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer .md-dialog-container')),
            targetEvent: $event,
            clickOutsideToClose: true,
            multiple: true,
            locals: {
                count: items.length,
                option: null
            }
        }).then(() => {
            let itemIds = items.map(item => item.get('id'))
            this.$http.post('items/delete/bulk', itemIds).then(() => {
            })
        })
    }

    deleteItem (yBlock, yItem, item) {
        let id = item.get('id')
        let title = item.get('title').toString()
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer .md-dialog-container')),
            multiple: true
        }).then(() => {
            this.Item.delete({ id: id }, () => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.delete?object=item&title=' + title,
                    hideDelay: 6000,
                    position: ('top right')
                })
            })
        })
    }

    createItemAfter (afterItemId, yBlock) {
        if (!this.isCreateItemAllowed) {
            console.warn('You are creating items to fast. Please slow down')
            return
        }

        this.isCreateItemAllowed = false
        setTimeout(() => {
            this.isCreateItemAllowed = true
        }, 500)

        this.Item.save({
            block_id: yBlock.get('id'),
            tags: [],
            contacts: [],
            afterItemId: afterItemId,
            placeOnEndOfBlock: !afterItemId
        })
    }

    initItemData (itemId) {
        if (!this.extraItemData[itemId]) {
            this.extraItemData[itemId] = {}
        }
    }

    indexOfItem (block, item) {
        let itemArray = block.get('items').toArray()
        for (let i = 0; i < itemArray.length; i++) {
            if (itemArray[i].get('id') === item.get('id')) {
                return i
            }
        }

        return -1
    }

    onDragStart (item, event) {
        if (this.selector.selectedItems.length === 0 || !this.selector.isAllowedToBeSelected(item)) {
            this.selector.removeAll()
            this.selector.add(item)
        }

        this.selector.selectedItems.filter(
            yItem => yItem.get('status') !== ITEM_STATE_SCHEDULED
        ).map(yItem => this.selector.remove(yItem))

        this.isDragging = true

        this.selector.setDraggingItem()

        event.dataTransfer.setDragImage(event.target.children[1], 0, 0)
    }

    onDrop (index, yBlock, event) {
        dndCleanupFix('#rundownContainer')

        if (this.$rootScope.filteredRundown) {
            return this.$mdDialog.show({
                templateUrl: 'dragDropFiltersWarning.ngTemplate',
                controller: 'DragDropFiltersWarning',
                parent: angular.element(document.querySelector('#popupContainer .md-dialog-container')),
                multiple: true
            }).then()
        }

        let itemArray = yBlock.get('items').toArray()
        //only drop above scheduled items!
        if (itemArray[index] && itemArray[index].get('status') !== ITEM_STATE_SCHEDULED) {
            return false
        }

        let selectedItems = this.selector.selectedItems

        if (event.ctrlKey) {
            for (let i = selectedItems.length; i > 0; i--) {
                if (selectedItems[(i - 1)].get('campaign_id')) {
                    selectedItems.splice((i - 1), 1)
                }
            }
            if (selectedItems.length === 0) {
                return false
            }

        }

        const droppedYItems = this.selector.getSelectedInOrder()
        this.$http.post('/items/dnd-items', {
            toType: { type: 'block', id: yBlock.get('id') },
            itemIds: this.yItemsToIds(droppedYItems),
            placeOnIndex: index,
            copySelection: event.ctrlKey
        }).then(({ data }) => {
            if (data.updatedItems) {
                for (const yItem of droppedYItems) {
                    const updateAtString = data.updatedItems[yItem.get('id')]
                    if (updateAtString) yItem.set('updated_at', updateAtString)
                }
            }
        })

        this.selector.removeAll()

        return true
    }

    onDragEnd () {
        this.isDragging = false
        this.selector.removeDraggingItem()
        this.selector.removeAll()
    }

    onSelected (yItem, yBlock, event) {
        let items = this.getItemsFromYBlock(yBlock)
        if (event.ctrlKey) {
            if (this.readOnly) return
            this.shouldCheckNextClick = true
            event.stopPropagation()
            event.preventDefault()

            this.selector.toggle(yItem)

        } else if (event.shiftKey) {
            if (this.readOnly) return
            this.shouldCheckNextClick = true
            event.stopPropagation()
            event.preventDefault()

            this.selector.add(yItem)
            if (this.selector.isAllowedToBeSelected(yItem)) {
                let a = this.selector.getIndex(this.selector.firstSelected)
                let b = this.selector.getIndex(yItem)
                let first, last

                if (a > b) {
                    first = b
                    last = a
                } else {
                    first = a
                    last = b
                }

                items.forEach((item, index) => {
                    let selected = (index >= first && index <= last)

                    let found = this.selector.indexOf(item)

                    if (selected && found === -1) {
                        this.selector.add(item)
                    } else if (!selected && found > -1) {
                        this.selector.remove(item)
                    }
                })
            } else {
                this.selector.add(yItem)
            }

        } else {
            const { widgets, $state } = this
            const path = getComposedEventPath(event)

            const focusPrep = () => {
                $state.go('rundown')
                    .then(() => {
                        this.$rootScope.$broadcast('rundownMenuUpdate', 'live')
                        setTimeout(() => window.focusPrep(yItem.get('id')), 100)
                    })
            }

            if (!path[0].classList.contains('item-control-btn')) {
                if (this.$state.current.name === 'rundown') {
                    window.focusPrep(yItem.get('id'))

                } else if (this.$state.current.name === 'rundown.widgets') {
                    const tabWidgets = widgets.getConnectionsFromTypeId('rundown_tab')
                    const currentWidgetId = parseInt($state.params.widget)

                    for (let id in tabWidgets) {
                        if (!tabWidgets.hasOwnProperty(id)) continue

                        const widget = tabWidgets[id]
                        if (widget.data_key) {

                            if (widget.settings.defaultAllowItemFocus) {
                                let content = null
                                let widgetData = yItem.get('widgets_data')[widget.data_key]
                                if (widgetData) content = widgetData.content
                                widgets.sendMessage(id, 'selectedItem', { itemId: yItem.get('id'), content })

                            } else if (widget.widgetId === currentWidgetId) {
                                focusPrep()
                            }
                        }
                    }
                } else if ($state.current.name !== 'rundown' && $state.current.name !== 'rundown.edit') {
                    focusPrep()
                }
            }
        }
    }

    // createView() {
    //     let maxHeight = this.scrollContainer.offsetHeight + (this.itemBufferSize * this.itemHeight);
    //     let currHeight = 0;
    //
    //     this.view = [];
    //     let blockArray = this.yBlocks.toArray();
    //     block : for (let i = 0; i < blockArray.length; i++) {
    //         if (currHeight > maxHeight) {
    //             break;
    //         }
    //
    //         let blockIndex = this.addBlock(i);
    //
    //         let itemArray = blockArray[i].get('items').toArray();
    //         if (itemArray.length == 0) {
    //             currHeight = currHeight + this.itemHeight; // no items placeholder
    //         } else {
    //             for (let ii = 0; ii < itemArray.length; ii++) {
    //                 if (currHeight > maxHeight) {
    //                     break block;
    //                 }
    //
    //                 currHeight = currHeight + this.itemHeight;
    //
    //                 this.view[blockIndex].items.push(itemArray[ii]);
    //             }
    //         }
    //     }
    // }
    //
    //
    // handleScroll() {
    //     let offset = Math.min(Math.max(0, Math.floor(this.scrollContainer.scrollTop / this.itemHeight) - this.itemBufferSize), this.maxOffset);
    //     console.log(Math.min(Math.max(0, Math.floor(this.scrollContainer.scrollTop / this.itemHeight) - this.itemBufferSize), this.maxOffset), Math.floor(this.scrollContainer.scrollTop / this.itemHeight) - this.itemBufferSize, this.maxOffset, this.currentOffset);
    //     this.updateViewItems(offset);
    // // }
    //
    //
    // updateViewItems(offset) {
    //     if (offset > this.currentOffset) {
    //         let loops = offset - this.currentOffset;
    //
    //         let firstBlock = this.view[0];
    //         let lastBlock = this.view[this.view.length - 1];
    //         this.$scope.$apply(() => {
    //             for (let i = 0; i < loops; i++) {
    //                 console.log('?', i);
    //
    //                 if (firstBlock.items.length == 0) {
    //                     this.view.shift();
    //                     firstBlock = this.view[0];
    //
    //                     this.updateScrollContainerTop(this.blockHeight + this.itemHeight);
    //                 } else {
    //                     firstBlock.items.shift();
    //                     if (firstBlock.items.length == 0) {
    //                         this.view.shift();
    //                         firstBlock = this.view[0];
    //
    //                         this.updateScrollContainerTop(this.blockHeight);
    //                     }
    //
    //                     this.updateScrollContainerTop(this.itemHeight);
    //                 }
    //
    //                 let response = this.addNextItem(lastBlock);
    //                 console.log(response.success);
    //                 lastBlock = response.block;
    //             }
    //         });
    //     } else if (offset < this.currentOffset) {
    //         let loops = -(offset - this.currentOffset);
    //
    //         let lastBlock = this.view[this.view.length - 1];
    //         let firstBlock = this.view[0];
    //         this.$scope.$apply(() => {
    //             for (let i = loops; i > 0; i--) {
    //                 console.log('!', i);
    //
    //                 if (lastBlock.items.length == 0) {
    //                     this.view.pop();
    //                     lastBlock = this.view[this.view.length - 1];
    //                 } else {
    //                     lastBlock.items.pop();
    //
    //                     if (lastBlock.items.length == 0) {
    //                         this.view.pop();
    //                         lastBlock = this.view[this.view.length - 1];
    //                     }
    //                 }
    //
    //                 firstBlock = this.addPrevItem(firstBlock, true);
    //             }
    //         })
    //     }
    //
    //     this.currentOffset = offset;
    // }
    //
    //
    // updateScrollContainerTop(amount) {
    //     let currTop = this.navContainer.style.top.slice(0, -2);
    //     currTop = parseInt(currTop) || 0;
    //     this.navContainer.style.top = (currTop + amount) + 'px';
    // }
    //
    //
    // addBlock(newBlockIndex) {
    //     if (newBlockIndex < this.yBlocks.toArray().length) {
    //         let newBlock = this.yBlocks.get(newBlockIndex);
    //
    //         let viewSize = this.view.push(
    //             {
    //                 blockIndex: newBlockIndex,
    //                 yObj: newBlock,
    //                 items: []
    //             }
    //         );
    //
    //         return viewSize - 1;
    //     } else {
    //         return null;
    //     }
    // }
    //
    //
    // addBlockAtStart(newBlockIndex) {
    //     if (newBlockIndex > -1) {
    //         let newBlock = this.yBlocks.get(newBlockIndex);
    //
    //         this.view.unshift(
    //             {
    //                 blockIndex: newBlockIndex,
    //                 yObj: newBlock,
    //                 items: []
    //             }
    //         );
    //
    //         return 0;
    //     } else {
    //         return null;
    //     }
    // }
    //
    //
    // getNextItem(block) {
    //     let lastItem = block.items[block.items.length - 1];
    //     let newItemIndex;
    //
    //     let itemArray = block.yObj.get('items').toArray();
    //     if (!lastItem) { // new block, just return the first item
    //         return itemArray[0];
    //     } else {
    //         for (let i = 0; i < itemArray.length; i++) {
    //             if (itemArray[i].get('id') == lastItem.get('id')) {
    //                 newItemIndex = i + 1;
    //                 break;
    //             }
    //         }
    //     }
    //
    //     if (newItemIndex >= itemArray.length) { // Item is not in this block
    //         return null;
    //     } else {
    //         return itemArray[newItemIndex];
    //     }
    // }
    //
    //
    // getPrevItem(block) {
    //     let firstItem = block.items[0];
    //     let newItemIndex;
    //
    //     let itemArray = block.yObj.get('items').toArray();
    //     if (!firstItem) { // new block, just return the last item
    //         return itemArray[itemArray.length - 1];
    //     } else {
    //         for (let i = 0; i < itemArray.length; i++) {
    //             if (itemArray[i].get('id') == firstItem.get('id')) {
    //                 newItemIndex = i - 1;
    //                 break;
    //             }
    //         }
    //     }
    //
    //     if (newItemIndex < 0) { // Item is not in this block
    //         return null;
    //     } else {
    //         return itemArray[newItemIndex];
    //     }
    // }
    //
    //
    // initView() {
    //     let items = this.numberOfItems();
    //     let blocks = this.yBlocks.toArray().length;
    //
    //     this.maxScroll = items * this.itemHeight + blocks * this.blockHeight;
    //     this.maxOffset = Math.floor((this.maxScroll - this.scrollContainer.offsetHeight) / this.itemHeight) - this.itemBufferSize;
    //
    //     // this.yBlocks.observeDeep(this.onObserveDeepHandler);
    // }
    //
    //
    // updateMaxScroll(amount) {
    //     this.maxScroll = this.maxScroll + amount;
    //     this.maxOffset = Math.floor((this.maxScroll - this.scrollContainer.offsetHeight) / this.itemHeight) - this.itemBufferSize;
    // }
    //
    //
    // onObserveDeep(events) {
    //     events.forEach(event => {
    //
    //         // @todo doesn't work anymore
    //
    //         if (event.path.length == 2 && event.path[1] == 'items') {
    //             if (event.type == 'insert') {
    //
    //                 let yBlock = this.yBlocks.get(event.path[0]);
    //                 let block = this.isBlockInView(yBlock.get('id'));
    //
    //                 if (block) {
    //                     this.$scope.$apply(() => {
    //
    //                         // try to find the item BEFORE the new item
    //                         let itemBeforeIndex = false;
    //                         if (event.index > 0) {
    //                             this.updateMaxScroll(this.itemHeight);
    //
    //                             let yBeforeItem = yBlock.get('items').get(event.index - 1);
    //                             itemBeforeIndex = this.isItemInView(block.items, yBeforeItem.get('id'));
    //                         }
    //
    //                         setTimeout(() => {
    //                             if (itemBeforeIndex !== false) {
    //                                 block.items.splice(itemBeforeIndex + 1, 0, event.values[0]);
    //                             } else { // Add at the start of block
    //                                 block.items.unshift(event.values[0]);
    //                             }
    //                         });
    //                     });
    //                 }
    //
    //             } else if (event.type == 'delete') {
    //                 console.log('delete!', event);
    //
    //                 this.updateMaxScroll(-this.itemHeight);
    //
    //                 let yBlock = this.yBlocks.get(event.path[0]);
    //                 let block = this.isBlockInView(yBlock.get('id'));
    //
    //                 if (block) {
    //                     this.$scope.$apply(() => {
    //                         let itemIndex = this.isItemInView(block.items, event.values[0].get('id'));
    //                         console.log('t1', itemIndex);
    //
    //                         if (itemIndex !== false) {
    //
    //                             // Delete from view
    //                             block.items.splice(itemIndex, 1);
    //
    //                             // Add new item in the last block
    //                             let lastBlock = this.view[this.view.length - 1];
    //
    //                             let response = this.addNextItem(lastBlock);
    //                             if (response.success == false) {
    //                                 let firstBlock = this.view[0];
    //                                 this.addPrevItem(firstBlock);
    //                                 this.updateScrollContainerTop(-this.itemHeight);
    //                                 this.currentOffset = this.maxOffset;
    //                             }
    //                         }
    //                     })
    //                 }
    //             }
    //         }
    //     });
    // }
    //
    //
    // addNextItem(block) {
    //     let newItem = this.getNextItem(block);
    //     if (newItem == null) {
    //         // Next block
    //         let newBlockIndex = this.addBlock(block.blockIndex + 1);
    //         console.log(newBlockIndex);
    //         if (newBlockIndex != null) { // null IS possible since we have (bufferSize / 2) spare items on the end
    //             block = this.view[newBlockIndex];
    //             let newItem = this.getNextItem(block);
    //             console.log('newItem', newItem);
    //
    //             if (newItem != null) {
    //                 block.items.push(newItem);
    //             } else {
    //                 console.log('t2');
    //             }
    //         } else {
    //             return {block: block, success: false};
    //         }
    //     } else {
    //         block.items.push(newItem);
    //     }
    //
    //     return {block: block, success: true};
    // }
    //
    //
    // addPrevItem(block, updateContainerTop = false) {
    //     let newItem = this.getPrevItem(block);
    //     if (newItem == null) {
    //         // Next block
    //         let newBlockIndex = this.addBlockAtStart(block.blockIndex - 1);
    //         if (newBlockIndex != null) { // null IS possible since we have (bufferSize / 2) spare items on the end
    //             block = this.view[newBlockIndex];
    //             let newItem = this.getPrevItem(block);
    //
    //             if (updateContainerTop) {
    //                 this.updateScrollContainerTop(-(this.blockHeight));
    //             }
    //
    //             if (newItem != null) {
    //                 block.items.unshift(newItem);
    //             }
    //         }
    //     } else {
    //         block.items.unshift(newItem);
    //     }
    //
    //     if (updateContainerTop) {
    //         this.updateScrollContainerTop(-this.itemHeight);
    //     }
    //
    //     return block;
    // }
    //
    //
    // isItemInView(viewItems, itemId) {
    //     for (let i = 0; i < viewItems.length; i++) {
    //         if (viewItems[i] && viewItems[i].get('id') == itemId) {
    //             return i;
    //         }
    //     }
    //
    //     return false;
    // }
    //
    //
    // isBlockInView(blockId) {
    //
    //     for (let i = 0; i < this.view.length; i++) {
    //         if (this.view[i].yObj.get('id') == blockId) {
    //             return this.view[i];
    //         }
    //     }
    //
    //     return false;
    // }
    //
    //
    // numberOfItems() {
    //     let count = 0;
    //     let blockArray = this.yBlocks.toArray();
    //
    //     for (let i = 0; i < blockArray.length; i++) {
    //         let itemArray = blockArray[i].get('items').toArray();
    //         for (let ii = 0; ii < itemArray.length; ii++) {
    //             count++;
    //         }
    //     }
    //
    //     return count;
    // }
}
